/**
 * 생성기가 화면 아래 가운데(ZusToaster)에 띄우는 토스트 — 생성 중 · 결과 · 중단 · 안내 · 20문제 가득.
 * 모양과 id 를 여기서만 정한다. 입력과 함께 봐야 하는 안내(다시 시도 등)는 토스트가 아니라 입력창 위 안내 줄이다.
 */
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { InformationmarkSmallCircleFillIcon } from '@zep-us/zus-icons';
import { zusToast } from '@zep/toast';

/** 생성 중 토스트 id — 같은 id 로 다시 부르면 그 자리에서 문구만 바뀐다(자료 읽는 중 → 만드는 중). */
export const AI_GENERATE_DOCK_RUNNING_TOAST_ID = 'ai-generate-dock-running';
const INFO_TOAST_ICON = <InformationmarkSmallCircleFillIcon size="md" fill={ICON_COLOR.alternative} aria-hidden />;
export const aiGenerateDockToasts = {
  /** 생성 중 — 끝날 때까지 떠 있고, 밀어서 닫을 수 없다. 중단은 action 으로만. */
  running: (title: string, cancel: {
    label: string;
    onClick: () => void;
  }) => zusToast.loading(title, {
    id: AI_GENERATE_DOCK_RUNNING_TOAST_ID,
    action: cancel,
    dismissible: false
  }),
  dismissRunning: () => zusToast.dismiss(AI_GENERATE_DOCK_RUNNING_TOAST_ID),
  /** 성공 · 일부 성공 */
  success: (message: string) => zusToast.success(message),
  /** 성공이 아닌 알림(ⓘ) — 중단 · 문항이 들어온 뒤의 안내 */
  info: (message: string) => zusToast.success(message, {
    icon: INFO_TOAST_ICON
  }),
  error: (message: string) => zusToast.error(message),
  /** 20문제 가득(Figma 5-3) — 입력창을 여는 대신 띄운다. ⓘ 와 닫기 ✕. */
  limit: (copy: {
    message: string;
    close: string;
  }) => zusToast.success(copy.message, {
    icon: INFO_TOAST_ICON,
    dismissible: true,
    closeButtonLabel: copy.close
  })
};